module.exports = __webpack_public_path__ + "static/media/aspera_demo.3037091b.png";